import React from 'react';
import { classNames } from '../../utils/style';
import Polygon from '../../assets/images/polygon.svg';
import { PopoverPosition } from '.';

const getArrowPosition = (position?: PopoverPosition) => {
  switch (position) {
    case 'bottom':
      return 'top-[-11.8px] left-[calc(50%-12px)] rotate-180';
    case 'top':
      return 'top-[calc(100%)] left-[calc(50%-12px)]';
    case 'right':
      return 'top-[calc(50%-8px)] -left-[17.7px] rotate-90';
    case 'left':
      return 'top-[calc(50%-8px)] -right-[17.4px] rotate-[270deg]';
    default:
      return;
  }
};

export const PopoverArrow = ({
  position,
  className,
}: {
  position: PopoverPosition;
  className?: string;
}) => {
  const arrowPosition = getArrowPosition(position);
  return (
    <div
      className={classNames(
        'absolute transform border-b-white',
        arrowPosition,
        className,
      )}
    >
      <Polygon className="border-b-white" />
    </div>
  );
};
